import { Team } from '@/redux/types/team'

export const isValidTeamId = (
  teamId: number | null | undefined,
  teams: Team[]
): teamId is number =>
  teamId != null &&
  !Number.isNaN(teamId) &&
  teams.some((team) => team.id === teamId)

export const getTeamNameById = (
  teams: Team[],
  teamId: number | null | undefined
): string | null | undefined => {
  if (!teamId) return null
  const team = teams.find((t) => t.id === teamId)
  return team?.name || `Team ${teamId}`
}
